import { GuestCommsAnalyticsActionTypes } from './action-types';

export interface IInteractedWithGuestCommsActionPayload {
  action: 'clicked';
  location: 'guestComms';
  section: string;
  element: string;
  elementLabel: string;

  // Message
  websiteShareLink?: boolean;
  includeGuestName?: boolean;
  displayPassword?: boolean;
  subjectLine?: string;

  // Recipients
  numberOfGuests?: number;
  guestGroup?: 'Email - missing' | 'Events' | 'RSVP Status' | 'Guest groups';
}

export const interactedWithGuestCommsAction = (
  payload: IInteractedWithGuestCommsActionPayload,
) => ({
  type: GuestCommsAnalyticsActionTypes.INTERACTED_WITH_GUEST_COMMS,
  payload,
});
